import React, { useState } from 'react';
import { connect } from 'react-redux';
import { string, func } from 'prop-types';
import { Button } from '@tesla/design-system-react';
import { Checkbox, Form } from '@tesla/informed-tds';
import * as actions from '~/common/redux/actions';

import styles from './styles.module.css';

const SubmitButtonWithCheckbox = ({ iAmTransferring, submit, confirmTransferRequest }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = e => {
    setIsChecked(e.value);
  };

  const handleSubmitButtonClick = () => {
    confirmTransferRequest();
  };

  return (
    <div className={styles.Container}>
      <Form>
        <Checkbox
          name="checkbox"
          onChange={handleCheckboxChange}
          label={iAmTransferring}
          data-test="remove-confirm-transfer-checkbox"
        />
        <Button
          variant="primary"
          width="full"
          onClick={handleSubmitButtonClick}
          disabled={!isChecked}
          className={styles.Button}
          data-test="remove-confirm-transfer-button-submit"
        >
          {submit}
        </Button>
      </Form>
    </div>
  );
};

SubmitButtonWithCheckbox.propTypes = {
  iAmTransferring: string.isRequired,
  submit: string.isRequired,
  confirmTransferRequest: func.isRequired,
};
SubmitButtonWithCheckbox.defaultProps = {};

export default connect(
  null,
  actions
)(SubmitButtonWithCheckbox);
